import { StandardDispatchFunction } from './actionTypes';

export function esigSetAgreementRefIdAction(payload: unknown) {
  return function (dispatch: StandardDispatchFunction): void {
    dispatch({ type: 'ESIG_AGREEMENTREFID_SET', payload });
  };
}
